class MailgunHelper {
    static mailTemplatesDataset = [{
        label: 'Aanbiedingen',
        value: 'offer_mail'
    }];
}

export default MailgunHelper;